import Swiper from "swiper/bundle";
import { Pagination, A11y, Navigation } from "swiper/modules";
import { extendedCards } from "./extended-cards";

const swiper = new Swiper(".swiper", {
  // Optional parameters
  A11y: true,
  loop: true,
  autoplay: {
    delay: 5000,
  },
  slidesPerView: 1,
  spaceBetween: 24,
  breakpoints: {
    992: {
      slidesPerView: 3,
    },
  },

  on: {
    afterInit: extendedCards(),
  },

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },

  // And if we need scrollbar
  scrollbar: {
    el: ".swiper-scrollbar",
  },
});
